import { RootState } from 'src/types/RootState';
import { initialState } from './slice';
import { createSelector } from '@reduxjs/toolkit';

const selectDomain = (state: RootState) => state?.candidateWorkExperienceView || initialState;

export const selectWorkExperienceView = createSelector([selectDomain], state => state);
export const selectSelectedWorkExperience = createSelector([selectDomain], state => state.selectedWorkExperience);
